import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { megaGroups } from '../../data/navigation';
import { BOOKING_URL } from '../../data/site';
import { IMAGES } from '../../data/images';
import { ImageSlot } from '../ui/ImageSlot';
interface MegaMenuProps {
  id: string;
  onNavigate: () => void;
}
export function MegaMenu({
  id,
  onNavigate
}: MegaMenuProps) {
  return <motion.div id={id} initial={{
    opacity: 0,
    y: -6
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -6
  }} transition={{
    duration: 0.18,
    ease: [0.23, 1, 0.32, 1]
  }} className="absolute inset-x-0 top-full border-t border-white/10 bg-ink/[0.97] shadow-2xl backdrop-blur-md" data-id="element-391" data-mp="x3sho57y2nfi">
      <div className="gutter grid grid-cols-12 gap-8 py-10" data-id="element-392" data-mp="37tqyi6kvpc3d">
        <div className="col-span-9 grid grid-cols-5 gap-8" data-id="element-393" data-mp="37u91rn5ykqks">
          {megaGroups.map(group => <div key={group.title} data-id="element-394" data-mp="32x0l5r0gkuln">
              <p className="font-display text-sm font-semibold uppercase tracking-[0.12em] text-chrome-300" data-id="element-395" data-mp="14gnclenxb5ie">{group.title}</p>
              <span className="mt-3 block h-px w-8 bg-accent" aria-hidden="true" data-id="element-396" data-mp="19gjixkk3f914" />
              <ul className="mt-4 space-y-1" data-id="element-397" data-mp="1ee1nkyr2v23b">
                {group.links.map(link => <li key={link.label} data-id="element-398" data-mp="1j5tejae5b9tz">
                    <Link to={link.to} onClick={onNavigate} className="group flex items-baseline gap-2 rounded-sm py-1.5 text-[15px] text-white/90 transition-colors duration-150 hover:text-white" data-id="element-399" data-mp="1j6uo1afijo9l">
                      {link.code && <span className="w-12 shrink-0 font-display text-xs font-semibold tracking-wider text-chrome-500 group-hover:text-accent-bright" data-id="element-400" data-mp="1x387gp3lxzqp">
                          {link.code}
                        </span>}
                      <span data-id="element-401" data-mp="7pcwd9b7if3f">{link.label}</span>
                    </Link>
                  </li>)}
              </ul>
            </div>)}
        </div>
        <div className="col-span-3 flex flex-col overflow-hidden rounded-[4px] border border-white/10 bg-navy" data-id="element-402" data-mp="3qvzrtac4hslc">
          <ImageSlot image={IMAGES.classroom} decorative className="aspect-[16/8]" data-id="element-403" data-mp="9o5u7an8mywy" />
          <div className="flex flex-1 flex-col p-5" data-id="element-404" data-mp="4ot6yosgfptu">
            <p className="font-display text-lg font-semibold uppercase text-white" data-id="element-405" data-mp="4myn7dsx63rc">Need your permit?</p>
            <p className="mt-1 text-sm text-chrome-300" data-id="element-406" data-mp="imhszzy9d30h">The 8-hour Multi-State CCW runs multiple times every week.</p>
            <div className="mt-auto flex items-center gap-4 pt-4" data-id="element-407" data-mp="dndj173if193">
              <a href={BOOKING_URL} className="rounded-[3px] bg-accent px-4 py-2 font-display text-[13px] font-semibold uppercase tracking-wider text-white hover:bg-accent-bright" data-id="element-408" data-mp="sdks4w7mn7x4">
                Book CCW
              </a>
              <Link to="/courses" onClick={onNavigate} className="flex items-center gap-1 text-sm font-medium text-white hover:underline" data-id="element-409" data-mp="11cpsm82r1bbx">
                All courses <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-410" data-mp="1g196t6hoikdy" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </motion.div>;
}